export const headerHeightBig = 85;
export const headerHeightSmall = 65;